module.exports = __webpack_public_path__ + "static/media/kids_10.dedf5d33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_10.jpg
// module id = 5866
// module chunks = 0